import React from "react";

import { List,Datagrid,TextField,DateField, BooleanField, ShowButton, EditButton, DeleteButton, ImageField, BooleanInput} from "react-admin";


 export const NewsList = (props)=>(
    <List {...props}>
        <Datagrid>
            <TextField source="title" label="Titulo"/>
            <DateField source="date" label ="Fecha"/>           
            <ImageField source="image" label="Imagen"/>
           
            <EditButton/>
            
        </Datagrid>
    </List>

);



